export default __webpack_public_path__ + "static/media/medProsLogoLarge.4d8f19f4.svg";